// extracted by mini-css-extract-plugin
export default {"logo":"MainLogo_logo__XbXnS","open":"MainLogo_open__-K2pK"};